import { Injectable, Injector } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { EndpointFactory } from '../endpoint-factory.service';
import { ConfigurationService, ForceBaseUrl } from '../configuration/configuration.service';
import { CaseViewModel, IAdvanceStageResult, IHistoricItem, RollbackCaseStageRequestData, AssignCaseOwnershipRequest } from 'src/app/models/case';

@Injectable({
    providedIn: 'root'
})
export class CaseEndpoint extends EndpointFactory {


    getServiceBaseUrl(force?: ForceBaseUrl) {
        return this.getBaseUrl('case', force) + 'case';
    }

    constructor(http: HttpClient, configurations: ConfigurationService, injector: Injector) {

        super(http, configurations, injector);
    }


    addCase(base64: string, type: string, context?: {}): Observable<CaseViewModel> {
        const endpointUrl = `${this.getServiceBaseUrl()}/${base64}/${type}`;

        return this.http.post<CaseViewModel>(endpointUrl, context).pipe(
            catchError(error => {
                return this.handleError(error);
            }));
    }


    getCurrentCaseByCategoryEndpoint(base64: any, productCategory: string): Observable<CaseViewModel> {
        const endpointUrl = `${this.getServiceBaseUrl()}/${base64}/${productCategory}/current`;

        return this.http.get<CaseViewModel>(endpointUrl).pipe(
            catchError(error => {
                return this.handleError(error);
            }));
    }

    getCaseRawDetails(tenantId: string, caseId: number): Observable<any> {
        const endpointUrl = `${this.getServiceBaseUrl()}/${tenantId}/${caseId}`;

        return this.http.get<any>(endpointUrl).pipe(
            catchError(error => {
                return this.handleError(error);
            }));
    }

    getCasesByCategoryEndpoint(base64: any, productCategory: string): Observable<CaseViewModel[]> {
        const endpointUrl = `${this.getServiceBaseUrl()}/${base64}/${productCategory}`;

        return this.http.get<CaseViewModel[]>(endpointUrl).pipe(
            catchError(error => {
                return this.handleError(error);
            }));
    }

    rollbackCaseStage(rollbackCaseStageRequestData: RollbackCaseStageRequestData) {
        const endpointUrl = `${this.getServiceBaseUrl()}/rollbackcasestage`;
        return this.http.put<string>(endpointUrl, rollbackCaseStageRequestData).pipe<string>(
            catchError(error => {
                return this.handleError(error);
            }));
    }

    assignCaseOwnership(assignCaseOwnershipRequest: AssignCaseOwnershipRequest) {
        const endpointUrl = `${this.getServiceBaseUrl()}/assigncaseownership`;
        return this.http.put<string>(endpointUrl, assignCaseOwnershipRequest).pipe<string>(
            catchError(error => {
                return this.handleError(error);
            }));
    }

    advanceStageEndpoint(base64: string, orchestrationExternalId: string, actionId: string, payload: { [key: string]: any }): Observable<IAdvanceStageResult> {
        const endpointUrl = `${this.getServiceBaseUrl()}/${base64}/advance/${orchestrationExternalId}?actionId=${actionId}`;
        return this.http.post<IAdvanceStageResult>(endpointUrl, payload).pipe<IAdvanceStageResult>(
            catchError(error => {
                return this.handleError(error);
            }));
    }

    updateCaseCustomData(base64: string, caseExternalId: string, metadata: any) {
        const endpointUrl = `${this.getServiceBaseUrl()}/${base64}/metadata/${caseExternalId}`;
        return this.http.put<IAdvanceStageResult>(endpointUrl, metadata).pipe<IAdvanceStageResult>(
            catchError(error => {
                return this.handleError(error);
            }));
    }


}
